import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const ThickCheckIcon = (props: IconProps) => (
  <Icon w="12px" h="12px" viewBox="0 0 12 12" {...props}>
    <path d="M11.1069 3.3501L4.3999 10.0571L0.893066 6.55029L2.30029 5.14307L4.3999 7.24268L9.69971 1.94287L11.1069 3.3501Z" />
  </Icon>
);

export default memo(ThickCheckIcon);
